module.exports = __webpack_public_path__ + "img/coffee-640.553549cb.jpg";